module.exports = __webpack_public_path__ + "static/media/tournament_active.7795e554.svg";